<div class="part-search-modal">
  <div class="flex">
    <div class="flex-1 p-4">
      <div
        #videoContainer
        [ngClass]="{'is-scan-active': isScanningActive}"
      ></div>

      <form
        class="flex flex-col gap-2 md:!flex-row"
        [formGroup]="searchFormGroup"
        (submit)="submit()"
      >
        <fip-form class="flex-1">
          <mat-form-field class="w-full" appearance="fill">
            <mat-label data-cy="part-input-label">Part Number</mat-label>
            <input
              data-cy="part-input-field"
              matInput
              formControlName="partNumber"
              type="text"
              placeholder="e.g. P1234.."
            />
          </mat-form-field>
        </fip-form>
        <fip-form formType="submit" class="h-10 md:h-auto">
          <fip-button
            dataCy="part-search-modal-btn"
            [loading]="(searchLoading$ | async)!"
            (clickEvent)="submit()"
            label="Search"
            backgroundColor="black"
            textColor="white"
            classes="px-3 py-2 md:ml-3 md:mt-0 sm:w-auto shadow-sm text-sm"
          ></fip-button>

          @if (featureFlagService.getFeatureVisibility('codeScanning') ===
          'enabled') {
          <fip-button
            [iconRight]="'qr_code'"
            [iconType]="'material'"
            (clickEvent)="startScanning()"
            label="Scan Code"
            backgroundColor="black"
            textColor="white"
            classes="px-3 py-2 ml-3 md:mt-0 sm:w-auto shadow-sm text-sm"
            class="md:hidden"
          ></fip-button>
          }
        </fip-form>
      </form>

      @if (((searchLoading$ | async)) === false) { @if (searchResult ) {
      <div class="pt-10" data-cy="part-search-result">
        <div class="mx-auto max-w-7xl">
          <div class="mx-auto max-w-2xl lg:max-w-4xl">
            <div class="relative isolate flex flex-col gap-2 lg:flex-row">
              <!-- <div
                  class="relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-square lg:w-24 lg:shrink-0"
                  >
                  <img
                    src="https://placehold.co/600x400"
                    alt=""
                    class="absolute inset-0 h-full w-full bg-gray-50 object-cover"
                    />
                  <div
                    class="absolute inset-0 ring-1 ring-inset ring-gray-900/10"
                  ></div>
                </div> -->
              <div>
                <div class="relative max-w-xl">
                  <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    <span class="absolute inset-0"></span>
                    Found Part
                  </h3>
                </div>
                <div class="flex pt-6">
                  <div class="relative flex flex-col gap-x-4">
                    <div class="flex text-sm leading-6">
                      <p class="font-semibold text-gray-900">
                        <span class="absolute inset-0"></span>
                        Article ID:
                      </p>
                      <p class="ml-2 text-gray-600">
                        {{ searchResult.articleId }}
                      </p>
                    </div>
                    <div class="flex text-sm leading-6">
                      <p class="font-semibold text-gray-900">
                        <span class="absolute inset-0"></span>
                        Batch ID:
                      </p>
                      <p class="ml-2 text-gray-600">
                        {{ searchResult.batchId }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-10 flex gap-2">
          <fip-button
            label="Summary"
            backgroundColor="black"
            classes="px-3 py-1 text-sm hover:bg-accent-yellow group"
            (clickEvent)="navigateToSummary()"
          ></fip-button>
        </div>
      </div>
      } @else { @if (isSearchTriggered) {
      <div data-cy="part-search-no-result" class="pt-10">No results found.</div>
      } } }
    </div>
    <div
      data-cy="serial-numbers-list"
      class="hidden flex-1 self-stretch bg-gray-100 px-4 pb-10 pt-4 md:block"
    >
      <h4 class="text-base font-semibold leading-6 text-gray-900">Recent</h4>
      @if ((savedSerialNumbers$ | async)?.length === 0) {
      <p class="text-sm text-gray-500">You have no recent search.</p>
      } @else { @for (serialNumber of savedSerialNumbers$ | async; track
      serialNumber) {
      <button class="group mt-2 block text-sm" (click)="submit(serialNumber)">
        <p
          class="text-sm font-semibold leading-6 text-gray-900 group-hover:text-gray-500"
        >
          - {{ serialNumber }}
        </p>
      </button>
      } }
    </div>
  </div>
</div>
